module.exports = __webpack_public_path__ + "img/learning-to-fly-platform.d128473b.jpg";